import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'suka-topbar-global',
  template: `
    <ng-content></ng-content>
  `
})
export class TopbarGlobal {
  @HostBinding('class.topbar__global') hostClass = true;
}
